import script from "./TimelineSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TimelineSkeleton.vue?vue&type=style&index=0&id=58de6f82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58de6f82"]])

export default __exports__